// Shared leg row + live-score chip used by Autopilot History, X5
// Rollover and T20 Rollover panels. Pure display — reads the fields
// attached by the backend's `parlay_tracker.enrich_slip`
// (`tracker`, `score_home`, `score_away`, `status`, `minute`).
import HitTrackerBadge from "./HitTrackerBadge";

const LIVE_STATUSES_FE = new Set(["1H", "2H", "HT", "ET", "LIVE", "P", "BT"]);
const FINISHED_STATUSES_FE = new Set(["FT", "AET", "PEN", "FINISHED"]);

export const LegScoreChip = ({ leg }) => {
  const status = String(leg?.status || "").toUpperCase();
  const isLive = LIVE_STATUSES_FE.has(status);
  const isFinished = FINISHED_STATUSES_FE.has(status);
  const hg = leg?.score_home;
  const ag = leg?.score_away;
  const hasScore = hg != null && ag != null;
  return (
    <span className="inline-flex items-center gap-1">
      {isLive && (
        <span
          className="inline-flex items-center gap-1 text-[9px] uppercase tracking-[0.14em] font-bold text-rose-200 bg-rose-500/20 border border-rose-500/40 rounded-full px-1.5 py-0.5"
          data-testid="leg-live-pill"
        >
          <span className="w-1 h-1 bg-rose-400 rounded-full animate-pulse" />
          LIVE
          {status === "HT" ? " · HT" : (leg?.minute != null ? ` · ${leg.minute}'` : "")}
        </span>
      )}
      {hasScore && (
        <span
          className="font-bold font-tabular tabular-nums bg-white/5 border border-white/10 rounded px-1.5 py-0.5 text-[10px] text-slate-100"
          data-testid="leg-live-score"
        >
          {hg}-{ag}
        </span>
      )}
      {isFinished && !isLive && (
        <span className="text-[9px] uppercase tracking-[0.14em] text-slate-400 font-bold">
          {status === "FT" ? "FT" : status}
        </span>
      )}
    </span>
  );
};

export const LegRow = ({ leg }) => {
  return (
    <li className="py-2 flex items-start justify-between gap-3 text-sm">
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-white truncate">
            {leg.home_team} <span className="text-slate-500">vs</span> {leg.away_team}
          </span>
          <LegScoreChip leg={leg} />
        </div>
        <div className="text-emerald-300 text-xs mt-0.5">
          {leg.market_label} <span className="text-slate-500">/</span> {leg.pick}
          {leg.odds != null && (
            <span className="text-slate-500 ml-2">@ {Number(leg.odds).toFixed(2)}</span>
          )}
        </div>
        {leg.failure_reason && (
          <div className="text-rose-300 text-[11px] mt-1 flex items-center gap-1" data-testid="leg-failure-reason">
            <span className="font-semibold">Failed:</span>
            <span className="text-rose-200/80">{leg.failure_reason}</span>
          </div>
        )}
      </div>
      <div className="shrink-0 pt-0.5">
        <HitTrackerBadge tracker={leg.tracker || "pending"} />
      </div>
    </li>
  );
};
